import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { RESET_CONTENT_FEED_DECISIONING_MODAL } from "reducers/ContentFeedDecisioning";

const initialState = {
	data: [],
	isLoading: false,
	hasErrorLoading: false,
};

const CONTENT_FEED_MAPPING_ACTIONS = {
	FETCH_CONTENT_FEED_MAPPING_AJAX: "FETCH_CONTENT_FEED_MAPPING_AJAX",
	FETCH_CONTENT_FEED_MAPPING_SUCCESS: "FETCH_CONTENT_FEED_MAPPING_SUCCESS",
	FETCH_CONTENT_FEED_MAPPING_ERROR: "FETCH_CONTENT_FEED_MAPPING_ERROR",

	RESET_CONTENT_FEED_MAPPING: "RESET_CONTENT_FEED_MAPPING",
};

export const handlers = {
	[CONTENT_FEED_MAPPING_ACTIONS.FETCH_CONTENT_FEED_MAPPING_AJAX]: fetchContentFeedMapping,
	[CONTENT_FEED_MAPPING_ACTIONS.FETCH_CONTENT_FEED_MAPPING_SUCCESS]: fetchContentFeedMappingSuccess,
	[CONTENT_FEED_MAPPING_ACTIONS.FETCH_CONTENT_FEED_MAPPING_ERROR]: fetchContentFeedMappingError,

	[CONTENT_FEED_MAPPING_ACTIONS.RESET_CONTENT_FEED_MAPPING]: resetContentFeedMapping,
	[RESET_CONTENT_FEED_DECISIONING_MODAL]: resetContentFeedMapping,
};

let reducerConfig = {
	typeRoot: "CONTENT_FEED_MAPPING",
	actionTypes: CONTENT_FEED_MAPPING_ACTIONS,
	actionCreators: {
		loadContentFeedMapping,
		clearContentFeedMapping,
	},
	initialState,
	handlers,
};

export function loadContentFeedMapping(creativeIds = [], includeInactive = false) {
	return (dispatch) => {
		return dispatch({
			type: CONTENT_FEED_MAPPING_ACTIONS.FETCH_CONTENT_FEED_MAPPING_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				params: { creativeIds: creativeIds.toString(), includeInactive },
				gateway: "fca",
				version: 1,
				url: `creatives-feeds`,
				method: "get",
				success: CONTENT_FEED_MAPPING_ACTIONS.FETCH_CONTENT_FEED_MAPPING_SUCCESS,
				error: CONTENT_FEED_MAPPING_ACTIONS.FETCH_CONTENT_FEED_MAPPING_ERROR,
			},
		});
	};
}

export function clearContentFeedMapping() {
	return (dispatch) => {
		dispatch({
			type: CONTENT_FEED_MAPPING_ACTIONS.RESET_CONTENT_FEED_MAPPING,
		});

		return Promise.resolve({ success: true });
	};
}

function fetchContentFeedMapping(state) {
	return {
		...state,
		data: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

function fetchContentFeedMappingSuccess(state, action) {
	const { data } = action.payload;

	return {
		...state,
		data: data.data,
		isLoading: false,
		hasErrorLoading: false,
	};
}

function fetchContentFeedMappingError(state) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

function resetContentFeedMapping() {
	return {
		...initialState,
	};
}

export default createReducer(
	reducerConfig.initialState,
	reducerConfig.handlers
);
